export const PROPERTY_SOURCE_MODEL_NAME = 'inventory.Property'
export const PROPERTY_GROUP_SOURCE_MODEL_NAME = 'inventory.PropertyGroup'
export const TAG_SOURCE_DISPLAY = {
    [PROPERTY_GROUP_SOURCE_MODEL_NAME]: "Property Group",
    [PROPERTY_SOURCE_MODEL_NAME]: "Property Listing",
}
